import Text from 'components/3catinfo/Text';
import styles from '../cosNoticia.module.scss';
import { removeDoubleQuotesFromBlockquotes } from '@portal-internet/core';

const Cites = (props) => {
    let { text } = props;
    text = removeDoubleQuotesFromBlockquotes(text);
    return <Text text={text} dataTestId='cos-noticia-cita' className={styles.cita} />;
};

export default Cites;
